import type { Action } from './actions'

export type State = {
    pushNotation: boolean,
    enablePushNotation?: boolean,
    nextTimePushIsAllowed: number,
    sendFormError?: any,
    networkError?: any
}

const initialState: State = {
    pushNotation: false,
    nextTimePushIsAllowed: 0 // push is allowed for the first time
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PUSH_NOTATION':
            const { enablePushNotation } = action.data
            return {
                ...state,
                enablePushNotation,
                pushNotation: enablePushNotation ? state.pushNotation : false
            }
        case 'TOGGLE_PUSH_NOTATION':
            const { pushNotation } = action
            let { nextTimePushIsAllowed } = state
            /* If we show push Notation to user, next push will be allowed in 1 month */
            if (!pushNotation) {
                let now = new Date()
                now.setMonth(now.getMonth() + 1)
                nextTimePushIsAllowed = now.getTime()
            }

            return {
                ...state,
                nextTimePushIsAllowed,
                pushNotation
            }
        case 'LOGOUT':
            return initialState
        case 'NOTATION_ERROR':
            return {
                ...state,
                sendFormError: action.sendFormError
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError
            }
        default:
            return state
    }
}
